import React, { useState } from "react";
import { Card, ListGroup, Button, Modal } from "react-bootstrap";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./img.css";
import LatestUpdates from "./latestupdates";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from './footer';

const StudyVisas = () => {
    return (

        <>
            <Container className="mt-5">
                <Row>
                    {/* Left Section - Image and Title */}


                    <Col md={8} className="d-flex flex-column align-items-center ">
                        <Image src="./img/study.jpg" alt="Professional Year" fluid />
                        <h2 className="mt-3">Studying and Training Visas</h2>
                    </Col>

                    {/* Right Section - Latest Posts and Social Media */}
                    <Col md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                                <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"className="dropdown-item text-decoration-none"style={{ color: "#22327f" }}target="_blank"rel="noopener noreferrer">Permanent Residence visa (Subclass 191)</a></ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <SecondSection />
            <LatestUpdates />
            <Footer />
        </>
    );

};

 <LatestUpdates/>




export default StudyVisas;


const VisaPage = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 3;

    const visas = [
        { subclass: "Subclass 500", visa: "Student Visa", status: "Temporary" },
        { subclass: "Subclass 590", visa: "Student Guardian Visa", status: "Temporary" },
        { subclass: "Subclass 407", visa: "Training Visa", status: "Temporary" },
    ];

    // Filter visas based on search input
    const filteredVisas = visas.filter(
        (visa) =>
            visa.subclass.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visa.visa.toLowerCase().includes(searchTerm.toLowerCase()) ||
            visa.status.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination Logic
    const totalPages = Math.ceil(filteredVisas.length / entriesPerPage);
    const displayedVisas = filteredVisas.slice(
        (currentPage - 1) * entriesPerPage,
        currentPage * entriesPerPage
    );

    return (
        <div className="container my-4">
            {/* Visa List Title */}
            <h2 className="fw-bold text-center text-decoration-underline mt-4">
                List of Visas under this Category
            </h2>

            {/* Search Box */}
            <input
                type="text"
                className="form-control my-3"
                placeholder="Search visas..."
                value={searchTerm}
                onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1); // Reset to first page when searching
                }}
            />

            {/* Visa Table */}
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead className="table-light">
                        <tr>
                            <th>Visa Subclass</th>
                            <th>Visa</th>
                            <th>Residency Status</th>
                            <th>Learn More</th>
                        </tr>
                    </thead>
                    <tbody>
                        {displayedVisas.length > 0 ? (
                            displayedVisas.map((visa, index) => (
                                <tr key={index}>
                                    <td>{visa.subclass}</td>
                                    <td>{visa.visa}</td>
                                    <td>{visa.status}</td>
                                    <td>
                                        <a href="#" className="text-primary">
                                            Learn More
                                        </a>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center text-muted">
                                    No results found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                        className="btn btn-outline-secondary"
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                    >
                        &laquo; Previous
                    </button>

                    <span>
                        Showing {Math.min((currentPage - 1) * entriesPerPage + 1, filteredVisas.length)} to{" "}
                        {Math.min(currentPage * entriesPerPage, filteredVisas.length)} of {filteredVisas.length} entries
                    </span>

                    <button
                        className="btn btn-outline-secondary"
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                    >
                        Next &raquo;
                    </button>
                </div>
            )}

            {/* Feedback Button */}
            <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
        </div>
    );
};


const SecondSection = () => {
    return (
        <>
            <Container className="mt-4">

                {/* YouTube Embed Section */}
                <Row className="mt-3">
                    <Col md={8}>

                        <h3 className="fw-bold text-decoration-underline">Overview :</h3>
                        <p>This visa is for the Students and their guardians who want to visit Australia
                            for study purposes. This visa category allows people to visit Australia to study and work based on conditions applied on visa. months. Duration For this Visa depends on the duration of studies.</p>
                        <p>There are <strong>Three </strong>different types of Subclass (es) under this category as shown in the table below.</p>
                        <h4 className="fw-bold text-decoration-underline ">How to apply</h4>
                        <p>Application for Student visas need to be meet all the requirements as Requested by the Immigration DepAATment.</p>
                        <p>The Basic checklist includes :</p>
                        <ul>
                            <li>Completed Application form.</li>
                            <li>Genuine Temporary Entrant . </li>
                            <li>Proof for funds that you can support your stay and return.</li>
                            <li>Statement Of Purpose.</li>
                            <li>Other Supporting documents which may vary according to which stream you apply.</li>
                        </ul>
                        <p>We at Bajwa Immigration Consultants help you with your visitor visa application. You can reach us by the form below this table and our team will get back to you.</p>

                        <Container className="my-4">
                            {/* Heading */}
                            <h3 className="text-center mb-4 fw-bold">How To Meet GTE Requirements?</h3>

                            <Row className="align-items-center">
                                {/* Left Section - Text & Button */}
                                <Col md={4} className="text-center text-md-stAAT">
                                    <h4 className="fw-bold">Document Checklist Tool</h4>
                                    <Button variant="warning" className="fw-bold px-4 py-2 mt-2">
                                        <Link to="https://immi.homeaffairs.gov.au/visas/web-evidentiary-tool">
                                            OPEN NOW</Link>
                                    </Button>
                                </Col>

                                {/* Right Section - Video/Image */}
                                <Col md={8} className="text-center">
                                    <Col md={8}>
                                        <div className="ratio ratio-16x9">
                                            <iframe
                                                width="100%"
                                                height="400"
                                                src="https://www.youtube.com/embed/Uyhns445lRE"
                                                title="YouTube video"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    </Col>
                                </Col>
                            </Row>
                        </Container>
                        <VisaPage />
                      
                    </Col>

                    {/* Right Side: Sidebar Section (Reduced width + Added space) */}
                    <Col md={3} className="ms-5" > {/* Added margin-left (ms-4) */}
                        <Card className="p-3 text-center">
                            {/* Bajwa Immigration Image */}
                            <Image
                                src="./img/brand-logo.png"
                                alt="Bajwa Immigration Logo"
                                fluid
                                className="mb-3"
                            />

                            <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
                            <Button variant="danger" className="mb-3"><a href="https://www.youtube.com/embed/uOGAB9oYets">SUBSCRIBE</a></Button>

                            <h6 className="fw-bold">Book Consultation</h6>
                            <Button variant="warning">BOOK CONSULTATION</Button>

                            <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
                            {/* Facebook Embed */}
                            <iframe
                                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                                width="100%"
                                height="130"
                                style={{ border: "none", overflow: "hidden" }}
                                scrolling="no"
                                frameBorder="0"
                                allowFullScreen
                            ></iframe>

                            {/* Social Media */}
                            <h6 className="fw-bold mt-3">We are also on:</h6>
                            <div className="d-flex justify-content-center gap-3">
                                <FaInstagram size={30} color="#C13584" />
                                <FaTiktok size={30} color="#000" />
                                <FaYoutube size={30} color="crimson" />
                            </div>
                        </Card>
                    </Col>
                </Row>

            </Container>

        </>
    );
};

